import D1 from '../../components/ExcerciseTypes/Design/TypeIn';


const json = {
  1: { // Exercise num
    unit: 'Unit 7',
    id: 'WB4-V2-U7-P49-E1',
    audio: '',
    video: '',
    component: D1,
    padding: 0,
    checkUppercase: true,
    fontSize: 23,
    exerciseKey: 'img/FriendsPlus/Page49/E1/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page49/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page49/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page49/E1/3.jpg', input: true, answer: "She works in a school" },
        { url: 'img/FriendsPlus/Page49/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page49/E1/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page49/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page49/E1/7.jpg', input: true, answer: "He works in an airport" },
        { url: 'img/FriendsPlus/Page49/E1/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page49/E1/9.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page49/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page49/E1/11.jpg', input: true, answer: "He works in a fire station" },
        { url: 'img/FriendsPlus/Page49/E1/12.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page49/E1/13.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page49/E1/14.jpg' },
        { url: 'img/FriendsPlus/Page49/E1/15.jpg', input: true, answer: "He works in a store" },
        { url: 'img/FriendsPlus/Page49/E1/16.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page49/E1/17.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page49/E1/18.jpg' },
        { url: 'img/FriendsPlus/Page49/E1/19.jpg', input: true, answer: "She works in a hospital" },
        { url: 'img/FriendsPlus/Page49/E1/20.jpg' },
      ],
      [
        // Column11
        { url: 'img/FriendsPlus/Page49/E1/21.jpg' },
      ],




    ],
  },
  2: { // Exercise num
    unit: 'Unit 7',
    id: 'WB4-V2-U7-P49-E2',
    audio: '',
    video: '',
    textAlign: 'center',
    maxLength: 1,
    padding: 0,
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page49/E2/Key/answerKey.png',
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page49/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page49/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page49/E2/3.jpg', input: true, answer: "c" },
        { url: 'img/FriendsPlus/Page49/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page49/E2/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page49/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page49/E2/7.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page49/E2/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page49/E2/9.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page49/E2/10.jpg' },
        { url: 'img/FriendsPlus/Page49/E2/11.jpg', input: true, answer: "d" },
        { url: 'img/FriendsPlus/Page49/E2/12.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page49/E2/13.jpg' },
      ],


    ],
  },

}

export default json;